import styled from 'styled-components';

import { cCC38FF } from '#/colors';

const ButtonLink = styled.button.attrs({ type: 'button' })`
  background: none;
  border: none;
  color: ${cCC38FF};
  cursor: pointer;
  font-weight: 500;
  padding: 0;

  &:disabled {
    color: #ffffff55;
    cursor: progress;
  }
`;

export default ButtonLink;
